import styled from 'styled-components';

const ItemContainer = ({ children }) => {
  return <Container>{children}</Container>;
};

export default ItemContainer;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;

  label {
    color: ${props => props.theme.input.label.fontColor};
    font-weight: ${props => props.theme.input.label.fontWeight};
    font-size: ${props => props.theme.input.label.fontSize};
  }
`;
